import { render, staticRenderFns } from "./FormDownloadPage.vue?vue&type=template&id=7bd1ae02"
import script from "./FormDownloadPage.vue?vue&type=script&lang=js"
export * from "./FormDownloadPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports